import React from 'react';
import CompareSlider from './compareSlider';
import {
  img011,
  img012,
  img021,
  img022,
  img031,
  img032,
} from '../img/before-after';

console.log(img011);

function BeforeAfter() {
  return (
    <div className="mt-auto">
      <h2 className="font-bold">
        تصاویر قبل و بعد شاگردان دوره شیپ آپ
        <div
          dir="rtl"
          className="text-center text-xs text-gray-500  mb-4 max-w-screen-lg mx-auto px-4
      ">
          برای مشاهده تصاویر بعد از دوره، لطفا بر روی نوار کشویی در وسط عکس
          بزنید و به سمت مخالف بکشید. این تصاویر به شما کمک می‌کند تا نتایج
          واقعی و تاثیر دوره شیپ آپ را مشاهده کنید.
        </div>
      </h2>

      <div className="grid md:grid-cols-3 grid-cols-1   justify-items-center rounded-lg p-2">
        <CompareSlider
          title=" ۵ "
          age="۴۰"
          newSize="۳۴"
          oldSize="۳۸"
          desc="   ۴  "
          img1={img011}
          img2={img012}
          duration="سه ماه"
          goal=""
        />
        <CompareSlider
          title=" ۲۱ "
          age="۲۹"
          newSize="۴۲"
          oldSize="۵۴"
          desc="  ۲۳  "
          img1={img021}
          img2={img022}
          duration="شش ماه"
        />
        <CompareSlider
          title=" ۱۵ "
          age="۲۹"
          oldSize="۴۴"
          newSize="۳۸"
          desc="  ۱۰  "
          img1={img031}
          img2={img032}
          duration="شش ماه"
        />
      </div>
    </div>
  );
}

export default BeforeAfter;
